import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from 'app/modules/auth'
import * as filters from 'app/modules/filters';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  filters: filters.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
  yield all([filters.saga()])
}
